import { liteClient as algoliasearch } from 'algoliasearch/lite';

export const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID || 'YOUR_APP_ID',
  process.env.REACT_APP_ALGOLIA_SEARCH_KEY || 'YOUR_SEARCH_KEY'
);

export const INDEX_NAME = process.env.REACT_APP_ALGOLIA_INDEX || 'research_papers';
